import { render, staticRenderFns } from "./AufgabenSchueler.vue?vue&type=template&id=5100a0fe&"
import script from "./AufgabenSchueler.vue?vue&type=script&lang=ts&"
export * from "./AufgabenSchueler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports